import React from 'react';
import { Configuration } from "../Contexts/Configuration"
import Direction from '../Types/Direction';
import ViewType from "../Types/ViewType"
import VerifyCoverageNode from '../Views/VerifyCoverageView/VerifyCoverageView';
import BankPageNode from '../Views/BankPageView/BankPageView';
import CurrentNumberNode from '../Views/CurrentNumberView/CurrentNumberView';
import EnterEmailNode from '../Views/EnterEmailView/EnterEmailView';
import FirstDataPageNode from '../Views/FirstDataPageView/FirstDataPageView';
import HomeUseNode from "../Views/HomeUseView/HomeUseView"
import IdentityCardNode from '../Views/DocumentsUploadView/DocumentsUploadView';
import OffersNode from '../Views/OffersView/OffersView';
import OptionsNode from '../Views/OptionsView/OptionsView';
import PaymentModeNode from '../Views/PaymentModeView/PaymentModeView';
import PaymentTypeNode from '../Views/PaymentTypeView/PaymentTypeView';
import PhonePlanNode from '../Views/PhonePlanView/PhonePlanView';
import PortabilityNumberNode from '../Views/PortabilityNumberView/PortabilityNumberView';
import SecondDataPageNode from '../Views/SecondDataPageView/SecondDataPageView';
import WifiCoverageNode from '../Views/WifiCoverageView/WifiCoverageView';
import LastPageNode from '../Views/LastPageView/LastPageView';

export interface NavigationNode
{
	content: () => React.ReactNode
	percentage?: number,
	previous: (context: Configuration) => ViewType | undefined,
	next: (context: Configuration) => ViewType | undefined
}

const nodes = new Map<ViewType, NavigationNode>([
	[ViewType.verifyCoverage, VerifyCoverageNode],
	[ViewType.homeUse, HomeUseNode],
	[ViewType.phonePlan, PhonePlanNode],
	[ViewType.currentNumber, CurrentNumberNode],
	[ViewType.portabilityNumber, PortabilityNumberNode],
	[ViewType.wifiCoverage, WifiCoverageNode],
	[ViewType.enterEmail, EnterEmailNode],
	[ViewType.firstDataPage, FirstDataPageNode],
	[ViewType.secondDataPage, SecondDataPageNode],
	[ViewType.offers, OffersNode],
	[ViewType.optionsView, OptionsNode],
	[ViewType.paymentType, PaymentTypeNode],
	[ViewType.paymentMode, PaymentModeNode],
	[ViewType.bankForm, BankPageNode],
	[ViewType.documentsUpload, IdentityCardNode],
	[ViewType.lastPage, LastPageNode]
])

export const getNode = (type: ViewType): NavigationNode | undefined => nodes.get(type)

export const getNextView = (context: Configuration, current: ViewType, direction: Direction): ViewType | undefined =>
{
	let node = getNode(current)

	if (direction === Direction.next)
	{
		return node?.next(context)
	}
	else
	{
		return node?.previous(context)
	}
}

export const validateNavigation = async (context: Configuration, from: ViewType): Promise<boolean> =>
{
	switch (from)
	{
		case ViewType.verifyCoverage:
			return context.validateVerifyCoverage?.() ?? false
		case ViewType.homeUse:
			return context.validateHomeUse?.() ?? false
		case ViewType.phonePlan:
			return context.validatePhonePlan?.() ?? false
		case ViewType.currentNumber:
			return context.validateCurrentNumber?.() ?? false
		case ViewType.portabilityNumber:
			return context.validatePortabilityNumber?.() ?? false
		case ViewType.wifiCoverage:
			return context.validateWifiCoverage?.() ?? false
		case ViewType.offers:
			return context.validateOffers?.() ?? false
		case ViewType.enterEmail:
			return context.validateEnterEmail?.() ?? false
		case ViewType.firstDataPage:
			return context.validateFirstDataPage?.() ?? false
		case ViewType.secondDataPage:
			return context.validateSecondDataPage?.() ?? false
		case ViewType.optionsView:
			return context.validateOptionsView?.() ?? false
		case ViewType.paymentType:
			return await context.validatePaymentTypeView?.() ?? false
		case ViewType.paymentMode:
			return context.validatePaymentModeView?.() ?? false
		case ViewType.bankForm:
			return context.validateBankPageView?.() ?? false
		case ViewType.documentsUpload:
			return await context.validateDocumentsView?.() ?? false
	}

	return true
}
